
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embed/newsletter-form/[newsletterFormId]",
      function () {
        return require("private-next-pages/embed/newsletter-form/[newsletterFormId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/embed/newsletter-form/[newsletterFormId]"])
      });
    }
  